import "mmenu-js/dist/mmenu";
import "mmenu-js/dist/mmenu.polyfills";
import {reInitScripts} from "../../utils/re-init-scripts";
let getMenuValuesRequest = null;

function getAvailableMenuItems () {
    $.ajax({
        url: '/' + window.currentLang + '/Account/GetAvailableMenuPoints',
        type: 'get',
        success: (response) => {
            $.each(response, (i, item) => {
                const $target = $(`[data-menu-id=${item.id}]`);
                if (!item.available) {
                    $target.hide();
                }
            });
            $('#mm-4').removeClass('mm-hidden');
            $('#mm-5').removeClass('mm-hidden');
        }
    });
}

function getMenuValues() {
    if (getMenuValuesRequest !== null) {
        getMenuValuesRequest.abort()
    }
    getMenuValuesRequest = $.ajax({
        url: '/' + window.currentLang + '/Account/GetMenuValues',
        type: 'get',
        success: (response) => {
            $.each(response, (i, item) => {
                const $target = $(`[data-menu-id=${item.id}]`);
                if ($target) {
                    if ($target.length) {
                        $target.get(0).style.setProperty('--count', `'${item.value}'`);
                        $target.attr('data-menu-values', item.value);
                    }
                }
            });
        }
    }).always(() => {
        getMenuValuesRequest = null;
    });
}

function menu(elements) {
    const defaultOptions = {
        slidingSubmenus: false,
        extensions: ["fx-menu-slide", 'border-none'],
        navbar: false,
        sidebar: {
            collapsed: "(min-width: 0px)",
            expanded: {
                use: "(min-width: 0px)",
                initial: 'remember'
            }
        },
        "navbars": [
            {
                "position": "bottom",
                "content": $('#nav-footer').html()
            }
        ]
    };

    $(elements).each((i, el) => {
        const clientOptions = $(el).data('options') || {};
        const options = $.extend(defaultOptions, clientOptions);
        const config = {
            offCanvas: {
                page: {
                    selector: "#layout-page"
                }
            },
            classNames: {
                fixedElements: {
                    fixed: "fix"
                }
            }
        };
        const menu = new Mmenu(el, options, config);

        reInitScripts($(el).find('[data-manager-card]').parent().get(0));

        const api = menu.API;
        api.bind('close:start', () => {
            api.closeAllPanels();
        });

        /*let noUser = $(el).find('[data-no-user]').text();
        if (noUser === false) {
            getAvailableMenuItems();
            getMenuValues();
        }*/

        getAvailableMenuItems();
        getMenuValues();
    });
    
    document.body.removeEventListener('keydown', document.body.mmEventKeydownTabguard[0]); // fix tabbing through input elements inside mmenu panel
}

export default function (elements) {
    menu(elements);
}